import Vue from 'vue';
import Vuex from 'vuex';
import conf from '../configs/index';
import createPersistedState from "vuex-persistedstate"

import { state, getters, actions, mutations } from './root';
import account from './modules/account';
import navigation from './modules/navigation';
import release from './modules/release';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: conf.debug,
    state,
    getters,
    actions,
    mutations,
    modules: { account,navigation,release },
    plugins: [
        createPersistedState({
            key: `${conf.name}`,
            storage: {
                getItem(key) {
                    let value = window.localStorage.getItem(key)
                    if (typeof value === 'string'){
                        try{
                            value = JSON.parse(value)
                        }catch(e){
                            console.error(e)
                        }
                    }

                    value = {
                        ...state,
                        ...value,
                        account: { ...account.state, ...value.account },
                        navigation: state.navigation, //导航设置不做本地化记录
                        release: state.release instanceof Array ? {}:state.release
                    }

                    return JSON.stringify(value)
                },
                setItem(key, value){
                    return window.localStorage.setItem(key, value)
                },
                removeItem(key){
                    return window.localStorage.removeItem(key)
                }
            }
        })
    ]
});
